/* eslint-disable @mizdra/layout-shift/require-size-attributes */
import React from 'react';
import proptypes from 'prop-types';
import { NUCLEUS_CHECKOUT_SAVED_PAYPAL, SIGN_IN } from '../constants/constants';
import { savedPaypalButtonClickNewRelic } from '../utils/NewRelicHelper';
import { goToUrl } from '../utils/utils';
// eslint-disable-next-line @harmony/stencil/no-import-css
import styles from './paypal-checkout-button.module.scss';

const { bool } = proptypes;
const SavedPaypalButton = (props) => {
  const { disabled, isAuthUser, isValidCart, payInFour } = props;

  const onClick = () => {
    try {
      savedPaypalButtonClickNewRelic(isAuthUser, isValidCart, payInFour);
      if (!isAuthUser) {
        goToUrl(SIGN_IN);
      } else if (isValidCart) {
        goToUrl(NUCLEUS_CHECKOUT_SAVED_PAYPAL);
      }
    } catch (error) {
      console.log(error);
    }
    return false;
  };

  return (
    <div>
      <button
        className={styles.savedPayPalButton}
        data-automation-id="saved-paypal-button"
        data-testid="saved-paypal-button"
        disabled={disabled}
        onClick={onClick}
        type="button"
      >
        <div className={styles.savedPayPalButton__labelContainer}>
          {!payInFour
            && (
              <>
                <div className={styles.savedPayPalButton__labelText}>
                  Use My Saved
                </div>
                <img
                  alt=""
                  className={styles.savedPayPalButton__labelImage}
                  role="presentation"
                  src="https://assets.homedepot-static.com/images/v1/paypal-logo-v3.svg"
                />
              </>
            )}
          <img
            alt=""
            className={styles.savedPayPalButton__labelImage}
            role="presentation"
            src="https://assets.homedepot-static.com/images/v1/paypal-logo-v2.svg"
          />
        </div>
      </button>
    </div>
  );
};

SavedPaypalButton.propTypes = {
  disabled: bool,
  isAuthUser: bool.isRequired,
  isValidCart: bool.isRequired,
  payInFour: bool.isRequired,
};

SavedPaypalButton.defaultProps = {
  disabled: false,
};

SavedPaypalButton.displayName = 'SavedPaypalButton';

export { SavedPaypalButton };
